export const testing = 'testing';

// setting the baseurl for api call from here

export const API_BASE_PATH: string | undefined = `${process.env.REACT_APP_API_BASE_PATH}/`;
